module.exports = __webpack_public_path__ + "static/media/img_3-11b.8f79f7cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/c-6/img_3-11b.png
// module id = 666
// module chunks = 0